import React from 'react';
import { GameColor } from '../../utils/GameColor.ts';
import styles from './UIGameTimerBar.module.scss';
import clsx from 'clsx';
// TODO: className input should have bottom: var(--safe-area-inset-bottom) when called from the mobile app
export function UIGameTimerBar({ className, currentTurnPlayerColor, timeLeftPercentage, isAnimated }) {
    const backgroundColor = GameColor.getPlayerBGDarkHashForMobile(currentTurnPlayerColor);
    const tickerStyle = {
        backgroundColor: backgroundColor,
        width: `${timeLeftPercentage}%`
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.timerBarParent, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.timerBar, isAnimated ? styles.active : ''),
        style: tickerStyle
    }));
}
